module.exports = {
    nav: {
        home: '首页',
        about: '关于我们',
        yan: '研发服务平台',
        pro: '产品中心',
        new: '新闻中心',
        jabout: '加入我们',
        contact: '联系我们',
        iupt:'搜索CAS号、产品名、英文名',
    },
    indexs:{
        aouts:'关于天宏达安',
        ke:'科研人员',
        gao:'50%高学历人才',
        pins:"平均5年以上行业经验",
        success:'成功审计',
        shun:'顺利通过FDA、NMPA',
        tga:'TGA和MFDS审查',
        quan:'全球客户',
        lc:'临床项目600',
        zai:"正在进行的商业项目30",
        zl:'专利',
        zlsl:'专利数量持续增长，涵盖美国、',
        orzh:"欧洲、日本、中国和韩国",
        fwfc:'服务范围',
        hese:'合作开拓创新',
        zqyp:'做全球药品生产研发的合伙人，从每个人，每个产品，每次服务开始。',
    },
    about:{
        abCen:'公司简介',
        zhjia:'专家团队',
        zhl:'质量合规',
        qiwen:'企业文化',
        tihxd:'天宏达安',
        fwts:'服务特色',
        shi:'我们的使命',
        hz:'合作开拓创新',
        yj:'我们的愿景',
        zqiu:'做全球药品生产研发的合伙人，从每个人，每个产品，每次服务开始',
    },
   
    pro:{
        cash:'cas号',
        zname:'中文名',
        fzs:'分子式',
        jgs:'结构式',
        proxi:'产品信息',
        yname:'英文名',
        fzl:'分子量',
        cpsx:'产品属性',
        yd:'熔点',
        fd:'沸点',
        md:'密度',
        zdp:'折射率',
        sd:'闪电',
        zctj:'储存条件',
        aqxx:'安全信息',
        wxxfh:'危险性符号',
   
        wxxbm:'危险类别码',
        hgbm:'海关编码',
        ckwx:'参考文献',
        xiazai:'下载',
        cdzl:'产品纯度质量报告下载',
    },
    join:{
        zw:'职位',
        bm:'部门',
        dd:'地点',
        yq:'要求',
    },
    cont:{
        ywzx:'业务咨询',
        gszj:'公司总机',
        gnywe:'国内业务邮箱',
        fzgw:'负责接收国内客户，技术咨询相关邮件',
        cz:'传真',
        zjyx:'证券事务邮箱',
        lxdh:'联系电话',
        yx:'邮箱',
        help:'我们能帮您什么呢',
        jdlxfs:'请填写下面的简短表格以取得联系',
        mz:'名字',
        xing:'姓',
        zc:'职称',
        gs:'公司',
        yj:'邮件',
        dh:'电话',
        gj:'国家',
        gxqfw:'感兴趣的服务',
        zs:'注释',
        wjsc:'文件上传',
        sbum:'提交',
        gs:'公司',
        bgxz:'表格下载',
        rgyw:'如果有业务方面的咨询，可以下载《询价单》填写后上传给我们。',
        xjd:'询价单',
        bzh:'保证函',
        wjsc:'文件上传',
        djsc:'点击上传',
    },
    more:'查看更多',
    news:'公司新闻',
    td:'简历投递方式',
    zwlb:'职位列表',
    email:'邮箱',
    ell:'联系方式',
    zpyq:'招聘要求',
    gzzw:'工作职责',
    zpxi:'招聘信息',
    ywzx:'业务咨询',
    dz:'地址',
    
}


// WEBPACK FOOTER //
// ./src/utils/lang/zh.js